import { smartService } from '../xstate/smart.xstate';

export interface SmartServiceUIState {
  isLoading: boolean;
  isError: boolean;
}

/**
 * Returns the current UI state derived from the smartService XState machine.
 * Call this inside render() or any reactive context where smartService.subscribe()
 * will trigger a re-render.
 *
 * - isLoading: service is not yet initialized or is in a transient state
 * - isError: service reached an unrecoverable state (incompatible backend)
 */
export function getSmartServiceUIState(): SmartServiceUIState {
  return {
    isLoading:
      !smartService.initialized ||
      smartService.state.matches('unconfigured') ||
      smartService.state.matches('validating'),
    isError: smartService.state.matches('incompatible'),
  };
}
